import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherAttributes, FeatherIconNames, icons } from 'feather-icons';
import { SafePipe } from 'src/app/core/pipes/safe.pipe';

@Component({
  selector: 'market-icon[iconName]',
  standalone: true,
  imports: [CommonModule, SafePipe],
  template: ` <span [innerHTML]="icon | safe: 'html'"></span> `,
})
export class IconComponent {
  @Input() iconName!: FeatherIconNames;
  @Input() attr: Partial<FeatherAttributes> = {};
  private _defaultAttr = { width: 16, height: 16 };
  get icon() {
    return icons[this.iconName].toSvg({ ...this._defaultAttr, ...this.attr });
  }
}
